import { GENERATED_LEVELS } from './levels.generated'
import { TIERS } from './tiers'
import type { Level } from './types'

/** The two tutorial levels are hand-made; everything after comes from the generator. */
const HANDMADE: readonly Level[] = [
  {
    id: 'first-steps',
    name: 'First steps',
    par: 3,
    tier: 1,
    intro: TIERS[0]!.intro,
    rows: [
      '##########',
      '#S.......#',
      '#........#',
      '#....#...#',
      '#........#',
      '#..#.....#',
      '#........#',
      '#......#.#',
      '#.#..D...#',
      '##########',
    ],
  },
  {
    id: 'thin-ice',
    name: 'Thin ice',
    par: 5,
    tier: 1,
    rows: [
      '##########',
      '#S....o..#',
      '#.#......#',
      '#........#',
      '#...o....#',
      '#........#',
      '#......#.#',
      '#........#',
      '#..#...oD#',
      '##########',
    ],
  },
]

export const LEVELS: readonly Level[] = [...HANDMADE, ...GENERATED_LEVELS]

export function levelById(id: string): Level | undefined {
  return LEVELS.find((l) => l.id === id)
}

export function levelNumber(id: string): number {
  return LEVELS.findIndex((l) => l.id === id) + 1
}

export function nextLevel(id: string): Level | undefined {
  const i = LEVELS.findIndex((l) => l.id === id)
  return i >= 0 ? LEVELS[i + 1] : undefined
}
